export default __webpack_public_path__ + "static/media/SZ08.586aedae.mp3";